import {format, parseISO} from "date-fns";

export const workScheduleSpecialCases = [
    { id: "COMMERCIAL", name: "Comercial"},
    { id: "COMMERCIAL6X1", name: "Comercial 6x1"},
    { id: "6x2", name: "6x2"}
];

export const workScheduleSpecialCasesMap = {
    COMMERCIAL: "Comercial",
    COMMERCIAL6X1: "Comercial 6x1",
    "6x2": "6x2",
};

export const AlertMessages = {
    "missing.name": "O campo \"Nome\" é obrigatório.",
    "duplicate.name": "Este \"Nome\" já está sendo utilizado.",
    "missing.startPeriod": "O campo \"Data inicial\" é obrigatório.",
    "missing.endPeriod": "O campo \"Data final\" é obrigatório.",
}

export const getStartOfDay = (date) => {
    if (!date) return null;
    return new Date(Date.UTC(
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
        0, 0, 0
    ));
}

export const getEndOfDay = (date) => {
    if (!date) return null;
    return new Date(Date.UTC(
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
        23, 59, 59
    ));
}

export function formatHolidaysEvent(holiday) {
    const currentYear = new Date()
    return {
        start: `${currentYear.getFullYear()}-${formatMonthLeftZero(holiday.month)}-${formatMonthLeftZero(holiday.day)}`,
        end: `${currentYear.getFullYear()}-${formatMonthLeftZero(holiday.month)}-${formatMonthLeftZero(holiday.day)}`,
        display: 'background',
        title: holiday.name.length > 20 ? holiday.name.slice(0, 19).concat('...') : holiday.name,
        className: 'holiday-events',
        isHoliday: true
    };
}

function formatMonthLeftZero(args) {
    return args < 10 ? `0${args}` : args;
}

export function agGridShiftComparator(a, b){
    if (a === b) return 0;

    const aIsComercial = /^commercial/i.test(a);
    const bIsComercial = /^commercial/i.test(b);

    if (aIsComercial && !bIsComercial) return 1;
    if (bIsComercial && !aIsComercial) return -1;

    if (aIsComercial && bIsComercial) return a.localeCompare(b);

    const parsePattern = (str) =>
        str.split("x")
            .map(v => parseInt(v, 10))
            .filter(n => !isNaN(n));

    const arrA = parsePattern(a);
    const arrB = parsePattern(b);

    if (arrA.length === 0) return 1;
    if (arrB.length === 0) return -1;

    const priority = { 12: 1, 24: 2, 8: 3, 6: 4 };
    const prioA = priority[arrA[0]] ?? 99;
    const prioB = priority[arrB[0]] ?? 99;

    if (prioA !== prioB) return prioA - prioB;

    if (arrA.length !== arrB.length) {
        if (arrA[0] === 6) {
            return arrB.length - arrA.length;
        }

        return arrA.length - arrB.length;
    }

    for (let i = 0; i < arrA.length; i++) {
        if (arrA[i] !== arrB[i]) {
            return arrA[i] - arrB[i];
        }
    }

    return 0;
};

export function toLocalDate(dateString) {
    if (!dateString) return null;
    const [y, m, d] = dateString.split("-").map(Number);
    return new Date(y, m - 1, d);
}

export function formatIsoDate(date) {
    if (!date) return "";

    try {
        return format(parseISO(date), 'dd/MM/yyyy HH:mm');
    } catch (error) {
        console.error("Erro ao formatar data:", date);
        return String(date);
    }
}